import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ShareService {
    public sharedEvent = new EventEmitter<any>();
}
